
import { SpinAndHoldCommonConfiguration } from "../../../api";
import { SpinAndHoldBonus } from "../SpinAndHold/SpinAndHold";
import { SpinAndHoldParams } from "../SpinAndHold/SpinAndHoldParams";
import { SpinAndHoldBonusPIXIAPP } from "../SpinAndHold/SpinAndHoldPIXIAPP";
import { SpinAndHoldBonusPIXIAPPResponsive } from "../SpinAndHold/SpinAndHoldPIXIAPPResponsive";
import { ExtendedSpinAndHold } from "./ExtendedSpinAndHold";
import { ExtendedSpinAndHoldPIXIApp } from "./ExtendedSpinAndHoldPIXIApp";
import { ExtendedSpinAndHoldPIXIAppResponsive } from "./ExtendedSpinAndHoldPIXIAppResponsive";

export interface IExtendedSpinAndHoldBonusFactory
{
	CreateExtendedSpinAndHoldBonus(gameName: string, params: SpinAndHoldParams, config: SpinAndHoldCommonConfiguration): SpinAndHoldBonus;
	CreateExtendedSpinAndHoldBonusPIXIApp(gameName: string, params: SpinAndHoldParams, config: SpinAndHoldCommonConfiguration): SpinAndHoldBonusPIXIAPP;
	CreateExtendedSpinAndHoldBonusPIXIAPPResponsive(gameName: string, params: SpinAndHoldParams, config: SpinAndHoldCommonConfiguration): SpinAndHoldBonusPIXIAPPResponsive;

}

export class ExtendedSpinAndHoldBonusFactory implements IExtendedSpinAndHoldBonusFactory
{
	public CreateExtendedSpinAndHoldBonus(gameName: string, params: SpinAndHoldParams, config: SpinAndHoldCommonConfiguration): SpinAndHoldBonus
	{
		return new ExtendedSpinAndHold(gameName, params, config);
	}

	public CreateExtendedSpinAndHoldBonusPIXIApp(gameName: string, params: SpinAndHoldParams, config: SpinAndHoldCommonConfiguration): SpinAndHoldBonusPIXIAPP
	{
		return new ExtendedSpinAndHoldPIXIApp(gameName, params, config);
	}

	public CreateExtendedSpinAndHoldBonusPIXIAPPResponsive(gameName: string, params: SpinAndHoldParams, config: SpinAndHoldCommonConfiguration): SpinAndHoldBonusPIXIAPPResponsive
	{
		return new ExtendedSpinAndHoldPIXIAppResponsive(gameName, params, config);
	}
}